import {Flex, Input, InputGroup, InputLeftElement } from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'

export const Navbar = () => {
  return (
    <Flex
      as="nav"
      align="center"
      justify="center"
      padding="1rem"
      bg="white"
      borderBottom="1px"
      borderColor="gray.200"
      height="64px"
    >
      <InputGroup maxW="600px">
        <InputLeftElement pointerEvents="none">
          <FiSearch color="gray.300" />
        </InputLeftElement>
        <Input
          placeholder="Search..."
          borderRadius="full"
          bg="gray.50"
          _placeholder={{ color: 'gray.400' }}
          _focus={{ 
            borderColor: 'blue.500',
            boxShadow: 'none'
          }}
        />
      </InputGroup>
    </Flex>
  )
} 